export default class ItemManager {
  /* tslint:disable:no-any */
  public items: { [x: string]: any } = {};

  /**
   * インスタンス
   */
  private static _instance: ItemManager;

  /**
   * このクラスのインスタンスを取得
   */
  public static getInstance(): ItemManager {
    // _inctanceが存在しない場合に、new ItemManager()を実行する。
    if (!this._instance) {
      this._instance = new ItemManager();
    }

    // 生成済みのインスタンスを返す
    return this._instance;
  }
}
